import React, { useRef, useState } from "react";

import Menu from "./Menu";
import SourceIcon from "../SourceIcon";
import Popper from "components/common/Popper";
import { ICaptionUrl } from "../captionUrls";
import {
  SelectorLabel,
  SelectorPrefix,
  SelectorChevron,
  SelectorContainer
} from "./styles";

interface IPreviewLinkSelector {
  domain?: string;
  favicon?: string;
  disabled?: boolean;
  captionUrls: ICaptionUrl[];
  scrapeResultsByUrl: { [url: string]: any };
  attachment: { url?: string; originalUrl?: string };
  onUrlSelected: (url: string) => void;
}

const PreviewLinkSelector: React.FC<IPreviewLinkSelector> = ({
  domain,
  favicon,
  disabled,
  captionUrls,
  scrapeResultsByUrl,
  attachment,
  onUrlSelected
}) => {
  const ref = useRef(null);
  const [showOptions, setShowOptions] = useState(false);

  const toggleShowOptions = (event: React.MouseEvent) => {
    // The whole card is an anchor to the article, so the toggle must not follow it.
    event.preventDefault();
    event.stopPropagation();
    setShowOptions(!showOptions);
  };

  const onOptionSelected = (url: string) => {
    setShowOptions(false);
    onUrlSelected(url);
  };

  return (
    <div ref={ref}>
      <SelectorContainer $disabled={disabled} onClick={toggleShowOptions}>
        <SelectorPrefix>Preview:</SelectorPrefix>
        <SourceIcon domain={domain} favicon={favicon} />
        <SelectorLabel>{domain}</SelectorLabel>
        <SelectorChevron />
      </SelectorContainer>
      {/*  @ts-ignore */}
      <Popper
        placement="bottom-start"
        referenceElement={ref.current}
        visible={showOptions}
        onClose={() => setShowOptions(false)}
        exceptions={[ref.current]}
      >
        <Menu
          attachment={attachment}
          captionUrls={captionUrls}
          scrapeResultsByUrl={scrapeResultsByUrl}
          onUrlSelected={onOptionSelected}
        />
      </Popper>
    </div>
  );
};

export default PreviewLinkSelector;
